import { PRODUCT_TYPES } from '../constants/index';
import { formatDate } from './index';

// Motor bilgisini firma ismi ve seçenekle formatla
const formatOrderMotorDisplay = (order) => {
  if (!order || (!order.motorType && !order.motorCompany)) return '';
  const option = order.motorType === 'Motor' ? 'Motor' : (order.motorType || 'Motor');
  const company = order.motorCompanyName || (order.motorCompany ? `Firma (${order.motorCompany})` : '');
  if (company && option) {
    return `${company} (${option})`;
  }
  return company || option;
};

// Tek sipariş için WhatsApp mesaj template'i oluştur
export const createSingleOrderWhatsAppMessage = (customerInfo, order, firmaInfo, subType = null) => {
  if (!customerInfo || !order) {
    return '';
  }

  const productType = PRODUCT_TYPES[order.productType]?.label || order.productType || '';
  const quantity = parseInt(order.quantity) || 1;

  // Ürün tipine göre detay bilgileri
  let orderDetails = '';

  // Not satırı (tüm tipler için ortak)
  const noteLine = order.notes ? `\n📝 *Not:* ${order.notes}` : '';

  // Katlamalı Perde için çoklu firma desteği
  if (order.productType === 'katlamaliPerde' && subType) {
    const usedM2 = parseFloat(order.usedM2) || 0;

    if (subType === 'kumas') {
      orderDetails = `
📦 *Sipariş Detayı (Kumaş):*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• Kullanılan Metre: ${usedM2.toLocaleString('tr-TR')} m
• Adet: ${quantity}`;
    } else if (subType === 'mekanizma') {
      orderDetails = `
📦 *Sipariş Detayı (Mekanizma):*
• Ürün Tipi: Katlamalı Perde
• Mekanizma Tipi: ${order.mechanismType || ''}
• Adet: ${quantity}`;
    } else if (subType === 'motor') {
      const motorDisplay = formatOrderMotorDisplay(order);
      orderDetails = `
📦 *Sipariş Detayı (Motor):*
• Ürün Tipi: Katlamalı Perde
• Motor: ${motorDisplay || 'Belirtilmedi'}
• Adet: ${quantity}`;
    } else if (subType === 'aksesuar') {
      let accLines = '';
      if (Array.isArray(order.accessories) && order.accessories.length > 0) {
        accLines = '\n• Aksesuarlar:';
        order.accessories.forEach(acc => {
          if (acc.name) accLines += `\n  - ${acc.name} (${acc.quantity} Adet)`;
        });
      } else {
        accLines = '\n• Aksesuar: Bilgi yok';
      }
      orderDetails = `
📦 *Sipariş Detayı (Aksesuar):*${accLines}
• Adet: ${quantity}`;
    }
  }
  // Tül ve Kanat için (subType desteği ile)
  else if ((order.productType === 'tul' || order.productType === 'kanat') && subType) {
    const usedM2 = parseFloat(order.usedM2) || 0;

    if (subType === 'kumas') {
      orderDetails = `
📦 *Sipariş Detayı (Kumaş):*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• Kullanılan Metre: ${usedM2.toLocaleString('tr-TR')} m
• Adet: ${quantity}`;
    } else if (subType === 'ozelTasarim') {
      const ozelUsedM2 = parseFloat(order.ozelUsedM2) || 0;
      const ozelQty = parseInt(order.ozelQuantity) || quantity;
      orderDetails = `
📦 *Sipariş Detayı (Özel Tasarım):*
• Özel Ürün Adı: ${order.ozelProductName || ''}${order.ozelProductVariant ? ` - ${order.ozelProductVariant}` : ''}
• Kullanılan Metre: ${ozelUsedM2.toLocaleString('tr-TR')} m
• Adet: ${ozelQty}`;
    } else if (subType === 'astar') {
      const usedM = parseFloat(order.usedM2) || 0;
      const astarQty = parseInt(order.quantity) || 1;
      orderDetails = `
📦 *Sipariş Detayı (Astar):*
• Astar Adı: ${order.astarProductName || ''}${order.astarProductVariant ? ` - ${order.astarProductVariant}` : ''}
• Kullanılan Metre: ${usedM.toLocaleString('tr-TR')} m
• Adet: ${astarQty}`;
    } else if (subType === 'aksesuar') {
      let accLines = '';
      if (Array.isArray(order.accessories) && order.accessories.length > 0) {
        accLines = '\n• Aksesuarlar:';
        order.accessories.forEach(acc => {
          if (acc.name) {
            if (acc.unit === 'metre') {
              accLines += `\n  - ${acc.name} (${acc.metre || '1'} m × ${acc.quantity} Adet)`;
            } else {
              accLines += `\n  - ${acc.name} (${acc.quantity} Adet)`;
            }
          }
        });
      } else {
        accLines = '\n• Aksesuar: Bilgi yok';
      }
      orderDetails = `
📦 *Sipariş Detayı (Aksesuar):*${accLines}`;
    }
  }
  // Tül ve Kanat için (subType yok — standart tekli gönderim)
  else if (order.productType === 'tul' || order.productType === 'kanat') {
    const usedM2 = parseFloat(order.usedM2) || 0;
    orderDetails = `
📦 *Sipariş Detayı:*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• Kullanılan Metre: ${usedM2.toLocaleString('tr-TR')} m
• Adet: ${quantity}`;
  } else if (order.productType === 'katlamaliPerde') {
    const usedM2 = parseFloat(order.usedM2) || 0;
    let accLines = '';
    if (Array.isArray(order.accessories) && order.accessories.length > 0) {
      accLines = '\n• Aksesuarlar:';
      order.accessories.forEach(acc => {
        if (acc.name) accLines += `\n  - ${acc.name} (${acc.quantity} Adet)`;
      });
    } else {
      accLines = '\n• Aksesuar: Bilgi yok';
    }

    const motorDisplay = formatOrderMotorDisplay(order);
    const motorLine = motorDisplay ? `\n• Motor: ${motorDisplay}` : '';

    orderDetails = `
📦 *Sipariş Detayı:*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• Mekanizma: ${order.mechanismType || ''}${motorLine}
• Kullanılan Metre: ${usedM2.toLocaleString('tr-TR')} m${accLines}
• Adet: ${quantity}`;
  }
  else if (order.productType === 'ahsapJaluzi' || order.productType === 'metalJaluzi') {
    // Jaluzi türleri için detay
    const width = parseFloat(order.width) || 0;
    const height = parseFloat(order.height) || 0;

    const yonLine = order.direction ? `\n• Yön: ${order.direction}` : '';
    const sistemLine = order.sistemTipi ? `\n• Sistem Tipi: ${order.sistemTipi}` : '';
    const motorDisplay = formatOrderMotorDisplay(order);
    const motorLine = motorDisplay ? `\n• Motor: ${motorDisplay}` : '';

    // Ahşap Jaluzi ek bilgileri
    const zigilLine = order.hasZigil ? `\n• Ahşap Zıgıl Sistemi: ✓` : '';
    const reduktorLine = order.hasReduktor ? `\n• Redüktörlü: ✓` : '';
    const kurdelaLine = order.hasKurdela ? `\n• Kurdelalı: ✓` : '';

    // Metal Jaluzi ek bilgileri
    const metalZigilLine = order.hasMetalZigil ? `\n• Zıgıl Sistem Telli Takım: ✓` : '';
    const metalReduktorLine = order.hasMetalReduktor ? `\n• Redüktörlü: ✓` : '';
    const ikiCamLine = order.hasIkiCamArasi ? `\n• İki Cam Arası Buton Sistem Takım: ✓` : '';

    orderDetails = `
📦 *Sipariş Detayı:*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• En(cm): ${width.toLocaleString('tr-TR')} cm
• Boy(cm): ${height.toLocaleString('tr-TR')} cm${yonLine}${sistemLine}${motorLine}${zigilLine}${reduktorLine}${kurdelaLine}${metalZigilLine}${metalReduktorLine}${ikiCamLine}
• Adet: ${quantity}`;
  } else if (order.productType === 'stor' || order.productType === 'zebra') {
    const width = parseFloat(order.width) || 0;
    const height = parseFloat(order.height) || 0;
    const yonLine = order.direction ? `\n• Yön: ${order.direction}` : '';
    const motorDisplay = formatOrderMotorDisplay(order);
    const motorLine = motorDisplay ? `\n• Motor: ${motorDisplay}` : '';


    // Ek Özellikler
    let jumboLine = '';
    let altEtekDilimLine = '';
    let kapaliKasaLine = '';
    let lazerLine = '';
    let lamaLine = '';
    let kasaLine = '';
    let beyazIsLine = '';

    if (order.productType === 'zebra') {
      jumboLine = order.hasZebraJumbo ? `\n• Jumbo Sistem: ✓` : '';
      altEtekDilimLine = order.hasZebraAltEtekDilim ? `\n• Alt Etek Dilim: ✓` : '';
      kapaliKasaLine = order.hasZebraKapaliKasa ? `\n• Kapalı Kasa: ✓` : '';
    } else {
      // Stor
      jumboLine = order.hasStorJumbo ? `\n• Jumbo Sistem: ✓` : '';
      altEtekDilimLine = order.hasStorAltEtekDilim ? `\n• Alt Etek Dilim: ✓` : '';
      kapaliKasaLine = order.hasStorKapaliKasa ? `\n• Kapalı Kasa: ✓` : '';
      lazerLine = order.hasStorAltEtekLazer ? `\n• Alt Etek Lazer: ✓` : '';
      lamaLine = order.hasStorDekoratifLama ? `\n• Dekoratif Lama: ✓` : '';
      kasaLine = order.hasStorDekoratifKasa ? `\n• Dekoratif Kasa: ✓` : '';
      beyazIsLine = order.hasStorAltEtekBeyazIs ? `\n• Alt Etek Beyaz İş: ✓` : '';
    }

    orderDetails = `
📦 *Sipariş Detayı:*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• En(cm): ${width.toLocaleString('tr-TR')} cm
• Boy(cm): ${height.toLocaleString('tr-TR')} cm${yonLine}${motorLine}${jumboLine}${altEtekDilimLine}${kapaliKasaLine}${lazerLine}${lamaLine}${kasaLine}${beyazIsLine}
• Adet: ${quantity}`;
  } else if (order.productType === 'dikeyPerde' || order.productType === 'dikeyPvc' || order.productType === 'dikeyStor') {
    const width = parseFloat(order.width) || 0;
    const height = parseFloat(order.height) || 0;
    const yonLine = order.direction ? `\n• Yön: ${order.direction}` : '';
    const motorDisplay = formatOrderMotorDisplay(order);
    const motorLine = motorDisplay ? `\n• Motor: ${motorDisplay}` : '';
    const fonLine = order.hasDikeyFon ? `\n• Fon: ${order.dikeyFonName || 'Var'} (${order.dikeyFonCount || 1} Adet)` : '';

    orderDetails = `
📦 *Sipariş Detayı:*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}${fonLine}
• En(cm): ${width.toLocaleString('tr-TR')} cm
• Boy(cm): ${height.toLocaleString('tr-TR')} cm${yonLine}${motorLine}
• Adet: ${quantity}`;
  } else if (order.productType === 'plise') {
    let pliseDetails = `• 1. Ürün: ${order.pliseProduct1Name || ''}`;
    if (order.pliseProduct1Variation) pliseDetails += `\n• 1. Ürün Kumaş: ${order.pliseProduct1Variation}`;
    if (order.pliseCaseVariation) pliseDetails += `\n• Kasa: ${order.pliseCaseVariation}`;

    const hasMultisistem = Array.isArray(order.pliseItems) && order.pliseItems.some(i => i.multisistem);
    if (order.pliseProduct2Name && hasMultisistem) {
      pliseDetails += `\n• 2. Ürün: ${order.pliseProduct2Name}`;
      if (order.pliseProduct2Variation) pliseDetails += `\n• 2. Ürün Kumaş: ${order.pliseProduct2Variation}`;
    }

    let itemsLine = '';
    if (Array.isArray(order.pliseItems) && order.pliseItems.length > 0) {
      itemsLine = '\n• Ölçü Listesi:';
      order.pliseItems.forEach((item, idx) => {
        const ms = item.multisistem ? ' (Multisistem)' : '';
        itemsLine += `\n  ${idx + 1}. ${item.width} x ${item.height} - ${item.quantity} Adet${ms}`;
      });
    }

    const globalQty = parseInt(order.quantity) || 1;
    const globalQtyLine = globalQty > 1 ? `\n• Toplam Set Adedi: ${globalQty}` : '';

    orderDetails = `
📦 *Sipariş Detayı:*
${pliseDetails}${itemsLine}${globalQtyLine}`;
  } else if (order.productType === 'rustik') {
    const width = parseFloat(order.width) || 0;

    let ayakDetails = `\n• Ayak Modeli: ${order.ayakModel || ''}`;
    if (order.ayakCap) ayakDetails += `\n• Ayak Çapı: ${order.ayakCap}`;
    if (order.ayakUzunluk) ayakDetails += `\n• Ayak Uzunluğu: ${order.ayakUzunluk}`;
    if (order.ayakRenkKodu) ayakDetails += `\n• Renk Kodu: ${order.ayakRenkKodu}`;
    ayakDetails += `\n• Ayak Sayısı: ${order.ayakSayisi || 0}`;
    if (order.ekAyakSayisi) ayakDetails += ` (+ ${order.ekAyakSayisi} Ek)`;

    let extraLines = '';
    if (Array.isArray(order.rustikRaySecenekleri) && order.rustikRaySecenekleri.length > 0) {
      extraLines += '\n\n• Ray Seçenekleri:';
      order.rustikRaySecenekleri.forEach(ray => {
        if (ray.name) extraLines += `\n  - ${ray.name} (${ray.quantity} cm)`;
      });
    }
    if (Array.isArray(order.rustikAksesuarlar) && order.rustikAksesuarlar.length > 0) {
      extraLines += '\n\n• Aksesuarlar:';
      order.rustikAksesuarlar.forEach(acc => {
        if (acc.name) extraLines += `\n  - ${acc.name} (${acc.quantity} Adet)`;
      });
    }

    orderDetails = `
📦 *Sipariş Detayı:*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• En(cm): ${width.toLocaleString('tr-TR')} cm${ayakDetails}${extraLines}
• Adet: ${quantity}`;
  } else if (order.productType === 'raySistemi') {
    const width = parseFloat(order.width) || 0;

    orderDetails = `
📦 *Sipariş Detayı:*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• En(cm): ${width.toLocaleString('tr-TR')} cm
• Adet: ${quantity}`;
  } else {
    // Diğer ürünler için
    const width = parseFloat(order.width) || 0;
    const height = parseFloat(order.height) || 0;
    orderDetails = `
📦 *Sipariş Detayı:*
• Ürün Adı: ${order.productName || ''}${order.productVariant ? ` - ${order.productVariant}` : ''}
• En(cm): ${width.toLocaleString('tr-TR')} cm
• Boy(cm): ${height.toLocaleString('tr-TR')} cm
• Adet: ${quantity}`;
  }

  // Mesaj template'i
  const message = `${firmaInfo.defaultMessage}

👤 *Müşteri:* ${customerInfo.name || ''}
${orderDetails}${noteLine}`;

  return message.trim();
};

// Çoklu sipariş için WhatsApp mesaj template'i oluştur (eski fonksiyon - gerekirse kullanılabilir)
export const createWhatsAppMessage = (customerInfo, orders, firmaInfo) => {
  if (!customerInfo || !orders || orders.length === 0) {
    return '';
  }

  // Toplam tutar hesaplanmaz — firmaya fiyat gönderilmez

  // Sipariş listesi oluştur
  const orderList = orders.map((order, index) => {
    const productType = PRODUCT_TYPES[order.productType]?.label || order.productType || '';

    // Plise için toplam adet hesapla
    let quantity = parseInt(order.quantity) || 1;
    if (order.productType === 'plise' && Array.isArray(order.pliseItems) && order.pliseItems.length > 0) {
      quantity = order.pliseItems.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0);
    }

    let productName = order.productName || '';
    if (order.productType === 'plise') {
      productName = order.pliseProduct1Name || '';
      if (order.pliseProduct2Name) productName += ` + ${order.pliseProduct2Name}`;
    } else if (order.productVariant) {
      productName += ` - ${order.productVariant}`;
    }

    return `${index + 1}. ${order.roomName || ''} - ${productType} - ${productName} (${quantity} adet)`;
  }).join('\n');

  // Mesaj template'i
  const message = `🏠 *EBRAR GORDIJNEN*

${firmaInfo.defaultMessage}

👤 *Müşteri Bilgileri:*
Ad Soyad: ${customerInfo.name || ''}
Telefon: ${customerInfo.phone1 || ''}
Adres: ${customerInfo.address || ''}

📦 *Sipariş Detayları:*
${orderList}

📅 Sipariş Tarihi: ${customerInfo.orderDate ? formatDate(customerInfo.orderDate) : ''}
${customerInfo.inspectionDate ? `🔍 Keşif Tarihi: ${formatDate(customerInfo.inspectionDate)}\n` : ''}🚚 Teslim Tarihi: ${customerInfo.deliveryDate ? formatDate(customerInfo.deliveryDate) : ''}

#EbrarGordijnen #Sipariş`;

  return message.trim();
};

// WhatsApp URL oluştur (mobil ve web uyumlu)
export const createWhatsAppURL = (phone, message) => {
  if (!phone || !message) {
    return '';
  }

  // Telefon numarasını temizle (sadece rakamlar)
  const cleanPhone = phone.replace(/[^0-9]/g, '');

  // Mesajı URL encode et
  const encodedMessage = encodeURIComponent(message);

  // Cihaz tipini kontrol et - iPad ve iPhone'da browser'da bile uygulama açsın
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isMac = /Mac|macOS/i.test(navigator.userAgent);

  // iPad Safari'de bile uygulama açsın (iPad'ler Mac olarak algılanabilir)
  const shouldUseMobileLink = isMobile || (isTouch && isMac);

  if (shouldUseMobileLink) {
    // Mobil cihazlarda veya touch destekli Mac'lerde (iPad) WhatsApp uygulamasını aç
    return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
  } else {
    // Gerçek Desktop'ta WhatsApp Web aç
    return `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encodedMessage}`;
  }
};

// Tek sipariş için WhatsApp gönderme fonksiyonu
export const sendSingleOrderWhatsAppMessage = (customerInfo, order, selectedFirma, subType = null) => {
  if (!selectedFirma || !customerInfo || !order) {
    alert('Lütfen firma seçin ve sipariş bilgilerini kontrol edin.');
    return;
  }

  try {
    // Mesaj oluştur
    const message = createSingleOrderWhatsAppMessage(customerInfo, order, selectedFirma, subType);

    if (!message) {
      alert('Mesaj oluşturulamadı. Lütfen bilgileri kontrol edin.');
      return;
    }

    // WhatsApp URL oluştur
    const whatsappURL = createWhatsAppURL(selectedFirma.phone, message);

    if (!whatsappURL) {
      alert('WhatsApp URL oluşturulamadı.');
      return;
    }

    // Yeni sekmede WhatsApp Web aç
    window.open(whatsappURL, '_blank');

  } catch (error) {
    console.error('WhatsApp gönderme hatası:', error);
    alert('WhatsApp mesajı gönderilemedi. Lütfen tekrar deneyin.');
  }
};

// Çoklu sipariş için WhatsApp gönderme fonksiyonu (eski fonksiyon - gerekirse kullanılabilir)
export const sendWhatsAppMessage = (customerInfo, orders, selectedFirma) => {
  if (!selectedFirma || !customerInfo || !orders || orders.length === 0) {
    alert('Lütfen firma seçin ve sipariş bilgilerini kontrol edin.');
    return;
  }

  try {
    // Mesaj oluştur
    const message = createWhatsAppMessage(customerInfo, orders, selectedFirma);

    if (!message) {
      alert('Mesaj oluşturulamadı. Lütfen bilgileri kontrol edin.');
      return;
    }

    // WhatsApp URL oluştur
    const whatsappURL = createWhatsAppURL(selectedFirma.phone, message);

    if (!whatsappURL) {
      alert('WhatsApp URL oluşturulamadı.');
      return;
    }

    // Yeni sekmede WhatsApp Web aç
    window.open(whatsappURL, '_blank');

  } catch (error) {
    console.error('WhatsApp gönderme hatası:', error);
    alert('WhatsApp mesajı gönderilemedi. Lütfen tekrar deneyin.');
  }
};
